import React, { Component } from 'react';
import NavMenu from '../../components/navMenu/navMenu';
import HeaderMenu from '../../components/headerMenu/headerMenu';
import '../../assets/css/common.less';
import './distributionSet.less';
import { requests, getToken, loadZhuKeToken, getLoginShopInfo, isNotNull,systemConfig,getZkShopName,getTaoteShopName,debounceOther, requestsAsync, messageShow  } from '../../utils/http';
import { Input, Select, Tabs, Button, Switch, Checkbox, Radio, Message, Loading, Tooltip, Tag, Dialog } from 'element-react';
import MyLoading from '../../components/showLoading/showLoading';
import ShowWarn from '../../components/showWarn/showWarn';
import ShowModal from '../../components/showModal/index.jsx';
import $ from 'jquery';
import NewUserGuide from '../../components/newUserGuide/index.jsx';
import { SyncCategoryRequest,GetCategoryBrandsRequest,GetTemplatesBySidReqeust,GetLogisticsTemplatesBySidReqeust } from '../../utils/api';
import SelectCategoryModule from '../../components/selectCategoryModule';
import SelectCategoryModuleV2 from '../../components/selectCategoryModuleV2';
import SelectBox from '../../components/selectBox';


class distributionSet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectShopId: "",//当前登录的店铺id，非阿里的
            selectShopName: '',//列表显示的店铺名称
            selectPlatformType: "WxVideo",//当前登录的店铺类型
            selectPostageId:'',//初始化选择的物流模板ID
            selectLogisticsId:'',//初始化选择的运费模板ID
            templates: [],//运费模板
            logisticsTemplates: [],    //物流模板
            isFirstTemplteSelect:true,
            isFirstLogisticsTemplteSelect:true,
            categorySwitch: true,//智能类目开关

            isShowAuth: false,
            deliveryTimeliness: [  //发货时效 现货+预售，这里如有变动，复制一份给deliveryTimelinessInitialize
                { id: 1, name: "现货", checked: false, value: "2", inventoryValue: "" },
                { id: 2, name: "5天内发货", checked: false, value: "5", inventoryValue: "" },
                { id: 3, name: "15天内发货", checked: false, value: "15", inventoryValue: "" },
                { id: 4, name: "45天内发货", checked: false, value: "45", inventoryValue: "" },

            ],//发货时效
            //和上面的时效一样，做初始化用
            deliveryTimelinessInitialize: [{ id: 1, name: "现货", checked: false, value: "2", inventoryValue: "" },{ id: 2, name: "5天内发货", checked: false, value: "5", inventoryValue: "" },{ id: 3, name: "15天内发货", checked: false, value: "15", inventoryValue: "" },{ id: 4, name: "45天内发货", checked: false, value: "45", inventoryValue: "" },],
            deliveryTimeData: [ //现货发货时间 当日发：9999   次日发：1  48小时：2
                { id: 1, name: "当日发", value: "9999", checked: false },
                { id: 2, name: "次日发", value: "1", checked: false },
                { id: 3, name: "48小时", value: "2", checked: true }
            ],
            deliveryEdmit: false,
            stockNum:100, //时效规格库存
            isOperateDeliveryTime:false,  //时效规格库存 是否禁用下拉框

            skuRequireProp:'auto',
            skuAutoMerge:'auto',
            skuAutoFillProp:'auto',
            skuAutoFillPropValue:true,
            skuAutoFillUnitPropValue:'auto',

            //抖音，三包
            threeGuaranteesByServiceTypeList:[{ id: 1, name: "维修", value: "1", checked: true },{ id: 2, name: "延保", value: "2", checked: false }],
            threeGuaranteesByDurationList:[{ id: 1, name: "30天", value: "30", checked: false },{ id: 2, name: "60天", value: "60", checked: true },{ id: 3, name: "90天", value: "90", checked: false },{ id: 4, name: "180天", value: "180", checked: false },{ id: 5, name: "365天", value: "365", checked: false }],

            syncCategoryMessageDailog:false,//同步类目弹窗
            showSelectCategoryModule:false,//类目选择弹窗
            showSelectCategoryModuleV2:false,//类目选择弹窗
            customCateList:[],//自定义铺货类目
            brandCategorys:[],//用户选择的类目
            brandList:[],//匹配列表

            listingBrandConfig:[{}],
            selectedListingBrandConfig:null
        };
    }
    componentDidMount() {
        var zhukeToken = getToken();
        var that = this;
        if (zhukeToken != "")
            that.loadData();
        else {

            setTimeout(() => {
                var zhukeTokenTwo = getToken();
                if (zhukeTokenTwo == "") {
                    var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
                    //var hasZhukeLoginShopTokens = "";//测试。
                    if (hasZhukeLoginShopTokens != null && hasZhukeLoginShopTokens != "" && hasZhukeLoginShopTokens != undefined) {
                        loadZhuKeToken(hasZhukeLoginShopTokens);

                        setTimeout(() => {
                            var zhukeTokenThree = getToken();
                            if (zhukeTokenThree != "")
                                that.loadData();
                            else
                                that.setState({ isShowWarn: true });

                        }, 500);
                    } else
                        that.setState({ isShowWarn: true });
                } else
                    that.loadData();
            }, 500);

        }
    }
    onChange(name,val){
        this.setState({ [name]:val },()=>{
            console.log(name+" =>",this.state[name]);
        });
    }
    changeNav = (name) => {
        this.props.history.replace(name)
    }
    loadData = () => {
        var shopInfo = getLoginShopInfo();
        var that = this;
        this.setState({
            selectShopId: shopInfo.loginShopId,
            selectShopName: shopInfo.loginShopName,
            selectPlatformType: shopInfo.loginShopPlatformType,
        }, () => {
            that.initData();
        })

    }




    initData = () => {
        this.setState({ //初始化
            isLoading: true,
            loadingTitle: '加载店铺信息...',
            showSelectsList: [],//初始化类目列表
            isMoreSelectShow: false,//类目选择框隐藏
            selectTitle: '',//初始化显示类目名称
            selectCategoryId: '',//初始化选择的类目（第三级）值
            selectPostageId:'',//初始化选择的物流模板ID
            selectLogisticsId:'',//初始化选择的运费模板ID
            templates: [],//初始化运费模板
            logisticsTemplates:[],//初始化物流模板
        });

       
       
        let that = this;
        requests({
            url: "/ListingConfig/GetConfigValue",
            data: { ShopId: this.state.selectShopId },
            success: function (res) {
                that.setState({ isLoading: false });
                if (res.Success) {
                    var configValue = JSON.parse(res.Data.Values);
                    that.initGetConfig(configValue);   //初始化  页面默认值
                    that.getTemplates();
                    if(that.state.selectPlatformType == "XiaoHongShu")
                    {
                        that.getLogisticsTemplates();
                        
                    }
                   
                } else {
                    Message({
                        showClose: true,
                        message: res.Message,
                        type: 'error'
                    });
                }
            },
            fail: (err) => { }
        });


    }

    getTemplates() {  //获取邮费模板
        let that = this;
        requests({
            url: "/ListingConfig/GetTemplatesBySid",
            data: { ShopId: this.state.selectShopId },
            success: function (res) {

                if (res.Success) {
                    that.setState({ templates: res.Data });
                    that.initTemplteSelect();
                } else {
                    if (res.Message != undefined && res.Message != null && res.Message.indexOf('授权') != -1) {
                        that.setState({ isShowAuth: true });
                    } else {
                        Message({
                            showClose: true,
                            message: "获取邮费模板错误：" + res.Message,
                            type: 'error'
                        });
                    }
                }
            },
            fail: (err) => { }
        });
    }
     getLogisticsTemplates() {  //获取物流模板
        let that = this;
        requests({
            url: "/ListingConfig/GetLogisticsTemplatesBySid",
            data: { ShopId: this.state.selectShopId },
            success: function (res) {

                if (res.Success) {
                    that.setState({ logisticsTemplates: res.Data });
                    that.initLogisticsTemplteSelect();
                } else {
                    if (res.Message != undefined && res.Message != null && res.Message.indexOf('授权') != -1) {
                        that.setState({ isShowAuth: true });
                    } else {
                        Message({
                            showClose: true,
                            message: "获取邮费模板错误：" + res.Message,
                            type: 'error'
                        });
                    }
                }
            },
            fail: (err) => { }
        });
    }

    initGetConfig(data) {  //初始化页面默认值
        //console.log("data",$)

        //console.log("data",data)
        let platformType = data.PlatformType;
        let shopId = data.ShopId;
        let CateList = data.CateList;
        if (CateList.length > 0) {
            let selectTitle = "";
            for (let i = 0; i < CateList.length; i++) {
                selectTitle += CateList[i].Name + '—';
            }
            this.setState({
                selectTitle: selectTitle.substr(0, selectTitle.length - 1),
                CateList: CateList
            })
        }

        let timeLinessList = data.TimeLinessList;
        if (timeLinessList == null || timeLinessList == undefined)
            timeLinessList = [];

        //var isPresellSpec  = timeLinessList[i].IsPresellSpec;
        if (platformType == "TouTiao") {
            var deliveryTimelineList = this.state.deliveryTimeliness;
            var deliveryTimeDataList = this.state.deliveryTimeData;
            var isOperateDeliveryTime = false;
            var stockNum = 0;
            for (let i = 0; i < timeLinessList.length; i++) {
                for (let j = 0; j < deliveryTimelineList.length; j++) {
                    if (deliveryTimelineList[j].id == 1 && timeLinessList[i].IsPresellSpec == false) {
                        deliveryTimelineList[j].checked = true;
                        deliveryTimelineList[j].value = timeLinessList[i].Days;
                        deliveryTimelineList[j].inventoryValue = timeLinessList[i].StockPercentum;
                        isOperateDeliveryTime = true;

                        //现货，下拉选择的赋值
                        for (let k = 0; k < deliveryTimeDataList.length; k++) {
                            if (deliveryTimeDataList[k].value == timeLinessList[i].Days)
                                deliveryTimeDataList[k].checked = true;
                            else
                                deliveryTimeDataList[k].checked = false;
                        }
                        stockNum += timeLinessList[i].StockPercentum;
                    } else if (deliveryTimelineList[j].id > 1 && timeLinessList[i].IsPresellSpec && deliveryTimelineList[j].value == timeLinessList[i].Days) {
                        deliveryTimelineList[j].checked = true;
                        deliveryTimelineList[j].inventoryValue = timeLinessList[i].StockPercentum;
                        stockNum += timeLinessList[i].StockPercentum;
                    }
                }
            }


            //用户没设置过的的情况下，初始化一个默认值
            if (timeLinessList.length == 0 && deliveryTimelineList.length > 0) {
                deliveryTimelineList[0].checked = true;
                deliveryTimelineList[0].inventoryValue = 100;
                isOperateDeliveryTime = true;
                stockNum = 100;
            }
            var deliveryEdmit = false;
            if (timeLinessList.length > 1)
                deliveryEdmit = true;


            var threeGuaranteesByDurationList=this.state.threeGuaranteesByDurationList;
            var threeGuaranteesByServiceTypeList=this.state.threeGuaranteesByServiceTypeList;

            //三包
            var threeGuaranteesByDuration=data.ThreeGuaranteesByDuration;
            var threeGuaranteesByServiceType=data.ThreeGuaranteesByServiceType;
            if(isNotNull(threeGuaranteesByDuration) && threeGuaranteesByDuration !=0)
            {
                threeGuaranteesByDurationList.forEach((item, index) => {
                    if (item.value == threeGuaranteesByDuration) 
                        item.checked = true
                     else 
                        item.checked = false
                });
                threeGuaranteesByServiceTypeList.forEach((item, index) => {
                    if (item.value == threeGuaranteesByServiceType) 
                        item.checked = true
                     else 
                        item.checked = false
                });
            }


            this.setState({
                deliveryTimeliness: deliveryTimelineList
                , deliveryEdmit: deliveryEdmit
                , isOperateDeliveryTime: isOperateDeliveryTime
                , deliveryTimeDataList: deliveryTimeDataList
                , stockNum: stockNum
                ,threeGuaranteesByDurationList:threeGuaranteesByDurationList
                ,threeGuaranteesByServiceTypeList:threeGuaranteesByServiceTypeList
            });
        }


        let useFixedPercentPriceConfig = data.UseFixedPercentPriceConfig;
        //$("input[name=categoryCheckedName][value=" + data.IsAutoMappingCate + "]").prop('checked', true);  //类目开关
        var categorySwitch = data.IsAutoMappingCate == "true" || data.IsAutoMappingCate == "True" || data.IsAutoMappingCate == true ? true : false;

        if(data.IsMigrationVideo == null || data.IsMigrationVideo == undefined)
        {
            data.IsMigrationVideo = '1';
        }

        this.state.skuRequireProp = data.SkuRequireProp || 'auto';
        this.state.skuAutoMerge = data.SkuAutoMerge || 'auto';
        this.state.skuAutoFillProp = data.SkuAutoFillProp || 'auto';
        this.state.skuAutoFillPropValue = data.SkuAutoFillPropValue || true;
        if(this.state.skuAutoFillPropValue  == 'False' || this.state.skuAutoFillPropValue  == 'false'){
            this.state.skuAutoFillPropValue = false;
        }else{
            this.state.skuAutoFillPropValue = true;
        }
        this.state.skuAutoFillUnitPropValue = data.SkuAutoFillUnitPropValue || 'auto';
        this.state.customCateList = (data.CateList) || [];
        this.state.listingBrandConfig = (data.ListingBrandConfig) || [{}];
        this.state.selectLogisticsId=data.LogisticsId;
        this.state.selectPostageId=data.PostageId;
        
        $("#frontSellingPriceInput").val(data.SalePricePercent); //商品售卖价 采购价 比例
        $("#laterSellingPriceInput").val(data.AddSalePrice); //商品售卖价 采购价 金额
        $("#frontUnderlineInput").val(data.SuggestSalePrice);        //商品划线加   比例(快手的)
        $("#laterUnderlineInput").val(data.AddSuggestSalePrice); //商品划线加   金额 (快手的)
        $("input[name=decimals][value=" + data.IsReserveDecimal + "]").prop('checked', true);  //商品售卖价 保留小数或四舍五入去掉小数
        $("input[name=inventorySetName][value='" + data.StockCountTime + "']").prop('checked', true);//扣减库存  库存计数设置
        $("input[name=IsMigrationVideoRadio][value='" + data.IsMigrationVideo + "']").prop('checked', true);//扣减库存  库存计数设置
        $("#actualPrice").val(data.SalePricePercent + data.AddSalePrice); //拼多多团购价
       
        $("input[name=putawayName][value=" + data.IsDirectUpload + "]").prop('checked', true);//扣减库存  库存计数设置
        $("input[name=PromiseDeliveryTime][value='" + data.PromiseDeliveryTime + "']").prop('checked', true);//承诺发货时间 


        $("input[name=isFoltName][value=" + data.IsFolt + "]").prop('checked', true);//是否支持假一赔十
        $("input[name=isDamageGuaranteeName][value=" + data.IsDamageGuarantee + "]").prop('checked', true);//是否坏损包退
        $("input[name=isFakeOnePayThreeName][value=" + data.IsFakeOnePayThree + "]").prop('checked', true);//是否假一赔三
        $("input[name=isRefundableName][value=" + data.IsRefundable + "]").prop('checked', true);//是否支持七天无理由退换货
        $("#serviceMobileInput").val(data.ServiceMobile);        //手机号

        if(data.IfreshRotRefund == '1'){
            $("input[name=ifreshRotRefund]").prop('checked', true);//扣减库存  库存计数设置
        }
        if(data.BrokenRefund == '1'){
            $("input[name=brokenRefund]").prop('checked', true);//扣减库存  库存计数设置
        }
        if(data.AllergyRefund == '1'){
            $("input[name=allergyRefund]").prop('checked', true);//扣减库存  库存计数设置
        }

        this.setState({
            categorySwitch: categorySwitch,
            useFixedPercentPriceConfig: useFixedPercentPriceConfig,
            listingConfig:data,
        });
    }

    inputNumber = (e, id) => {
      var value = e.nativeEvent.data;
      var vals = value;
      
      if(isNotNull(vals))
         vals= vals.replace('.', '');

      if (isNaN(vals) && vals != "") {
        Message({showClose: true,message: "只能输入数字或者带有.的值",type: 'warning'});
          $("#" + id).val('0');
      }

   }

   cancelModul = (typeName) => {
    this.setState({ [typeName]: false });
   }


    //智能类目开关
    categorySwitchOnChange = (checked) => {
      this.setState({ categorySwitch: checked });
    }
     //智能类目开关
    showSelectCategoryModule = () => {
        this.setState({
           showSelectCategoryModule: true,
        })
    }
    //智能类目开关
    showSelectCategoryModuleV2 = (item) => {
        this.setState({
           selectedListingBrandConfig:item,
           showSelectCategoryModuleV2: true,
        })
    }


    gotoShopList = () => {
      Message({showClose: true,message: "请到阿里操作下。或者联系我们！",type: 'warning'});
      this.cancelModul("isShowAuth");
     // $("#myShopListIndexId").click();
    }

    
    saveSet = () => {
        if (this.state.isShowWarn ==true) {
            Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
            return;
        }

      let frontSellingPriceInput = $("#frontSellingPriceInput").val();
      let laterSellingPriceInput = $("#laterSellingPriceInput").val();
      let frontUnderlineInput = $("#frontUnderlineInput").val();
      let laterUnderlineInput = $("#laterUnderlineInput").val();
      let templateId = $("#templatesSelectId").find("option:selected").val();   //运费模板id
      let templateValue = $("#templatesSelectId").find("option:selected").text();   //运费模板name
      let logisticsTemplateId = $("#logisticsTemplatesSelectId").find("option:selected").val();   //物流模板id
      let logisticsTemplateValue = $("#logisticsTemplatesSelectId").find("option:selected").text();   //物流模板name
      let serviceMobile = $("#serviceMobileInput").val();

      if (frontSellingPriceInput == ""&&this.state.selectPlatformType != "Pinduoduo") {
          Message({showClose: true,message: "采购价 比例不能为空",type: 'warning'});
          return;
      }
      if (laterSellingPriceInput == "") {
          Message({showClose: true,message: "采购价 金额不能为空",type: 'warning'});
          return;
      }
      //这两个是快手的
      if (this.state.selectPlatformType == "KuaiShou") {
          if (frontUnderlineInput == "") {
              Message({showClose: true,message: "只能输入数字或者带有.的值",type: 'warning'});
              return;
          }
          if (laterUnderlineInput == "") {
              Message({showClose: true,message: "只能输入数字或者带有.的值",type: 'warning'});
              return;
          }
      }
      if (templateValue == "" || !templateValue || templateValue == "请选择运费模板") {
          Message({showClose: true,message: "请选择运费模板！",type: 'warning'});
          return;
      }

      if(this.state.selectPlatformType == "XiaoHongShu") {
        if(logisticsTemplateValue == "" || !logisticsTemplateValue || logisticsTemplateValue == "请选择物流模板") {
            Message({showClose: true,message: "请选择运费模板！",type: 'warning'});
            return;
        }
       }

      if (this.state.selectPlatformType == "TouTiao") {
          var isNotCheck=false;
          var checkList = $("input[name='deliveryTimelinessInputName']");
          for (let i = 0; i < checkList.length; i++) {
              var ck = $(checkList[i]);
              if(ck.prop("checked"))
                 isNotCheck=true;
          }
          if(!isNotCheck)
          {
              Message({showClose: true,message: "发货时效，必选一个",type: 'warning'});
              return;
          }
      }

      if (this.state.selectPlatformType == "TouTiao" && this.state.stockNum !=100) {
          Message({showClose: true,message: "时效规格库存必须等于(=)100%",type: 'warning'});
          return;
      }

      if (this.state.selectPlatformType == "TouTiao") {
          var res = /^((0\d{2,3}-\d{7,8})|0\d{9}|0\d{10}|0\d{11}|(1\d{10}))$/;
          if (serviceMobile == 0 || serviceMobile == "" || !res.test(serviceMobile)) {
              Message({showClose: true,message: "售后电话需要填写11位手机号码！",type: 'warning'});
              return;
          }
      }


      var categoryValueList = this.state.CateList;

      let obj = {};//提交数据
      obj.PlatformType = this.state.selectPlatformType;   //平台名称
      obj.ShopId = this.state.selectShopId;               //选择店铺
      //obj.CateList = categoryValueList;                 //选中的产品目录

      //obj.IsAutoMappingCate = $("input[name=categoryCheckedName]:checked").val();//注释时间20220112，没有手动设置类目,只有开关
      obj.IsAutoMappingCate = this.state.categorySwitch;
      obj.SalePricePercent = frontSellingPriceInput;           //商品售卖价 采购价 比例
      obj.AddSalePrice = laterSellingPriceInput;          //商品售卖价 采购价 金额
      obj.IsReserveDecimal = $("input[name=decimals]:checked").val();           //商品售卖价 保留小数或四舍五入去掉小数       
      obj.SuggestSalePrice = frontUnderlineInput;                //商品划线加   比例
      obj.AddSuggestSalePrice = laterUnderlineInput;        //商品划线加   金额 

      obj.StockCountTime = $("input[name=inventorySetName]:checked").val();//扣减库存  库存计数设置
      obj.IsMigrationVideo = $("input[name=IsMigrationVideoRadio]:checked").val();//扣减库存  库存计数设置
      obj.PostageId = templateId;//运费模板id
      obj.PostageName = templateValue; //运费模板name    
      obj.LogisticsId = logisticsTemplateId;//运费模板id
      obj.LogisticsName = logisticsTemplateValue; //运费模板name                                             
      obj.IsDirectUpload = $("input[name=putawayName]:checked").val();      //上架设置：是否立即上架 
      obj.ServiceMobile = serviceMobile;

      obj.IsFolt = $("input[name=isFoltName]:checked").val();//是否支持假一赔十
      obj.IsDamageGuarantee = $("input[name=isDamageGuaranteeName]:checked").val();//是否坏损包退
      obj.IsFakeOnePayThree = $("input[name=isFakeOnePayThreeName]:checked").val();//是否假一赔三
      obj.IsRefundable = $("input[name=isRefundableName]:checked").val();//是否支持七天无理由退换货

      obj.SkuRequireProp = this.state.skuRequireProp;
        obj.SkuAutoMerge = this.state.skuAutoMerge;
        obj.SkuAutoFillProp = this.state.skuAutoFillProp;
        obj.SkuAutoFillPropValue = this.state.skuAutoFillPropValue;
        obj.SkuAutoFillUnitPropValue = this.state.skuAutoFillUnitPropValue;
      obj.CateList = this.state.customCateList;

      if(this.state.listingBrandConfig.length > 0)
      {
        const listingBrandConfigs= this.state.listingBrandConfig.filter(x => x.ListingBrandCategoryItem && x.ListingBrandCategoryItem.length)
                                                                .map(x => { return { ListingBrandCategoryItem : x.ListingBrandCategoryItem,ListingBrandConfigInfo:x.ListingBrandConfigInfo}})
        obj.ListingBrandConfig = listingBrandConfigs
      }else{
        obj.ListingBrandConfig = []
      }

      if (this.state.selectPlatformType == "Pinduoduo") {
          obj.PromiseDeliveryTime = $("input[name=PromiseDeliveryTime]:checked").val();//承诺发货时间 
          obj.StockCountTime = "CreateTime";//拼多多目前保存会提示，默认赋值
      }

      if (this.state.selectPlatformType == "KuaiShou") {
          obj.PromiseDeliveryTime = $("input[name=PromiseDeliveryTime]:checked").val();//承诺发货时间 
          obj.IsDirectUpload = true;//上架设置： 只有 立即上架 

          obj.IfreshRotRefund = $("input[name=ifreshRotRefund]").prop('checked') == true ? '1':'0';//坏了包退 
          obj.BrokenRefund = $("input[name=brokenRefund]:checked").prop('checked') == true ? '1':'0';//破损包退 
          obj.AllergyRefund = $("input[name=allergyRefund]:checked").prop('checked') == true ? '1':'0';//过敏包退 
      }

      if (this.state.selectPlatformType == "TouTiao")
      {
          obj.PromiseDeliveryTime = 48;//承诺发货时间  

          //20220428 追加,现货+预售
          var timeLinessList=[];
          var timeList= this.state.deliveryTimeliness;
          for (let i = 0; i < timeList.length; i++) {
              if(timeList[i].checked ==false)
                 continue;

              var isPresellSpec=false;//是否预售
              if(timeList[i].id !=1)
                 isPresellSpec=true;
              
                 
              timeLinessList.push({
               IsPresellSpec:isPresellSpec,
               Days: timeList[i].value,
               StockPercentum: timeList[i].inventoryValue,
              });
          }
          obj.TimeLinessList = timeLinessList;//现货+预售的时效


          var threeGuaranteesByDurationList= this.state.threeGuaranteesByDurationList;
          const threeGuaranteesByDuration = threeGuaranteesByDurationList.find(x => x.checked == true);
      
          var threeGuaranteesByServiceTypeList= this.state.threeGuaranteesByServiceTypeList;
          const threeGuaranteesByServiceType = threeGuaranteesByServiceTypeList.find(x => x.checked == true);


          obj.ThreeGuaranteesByDuration=threeGuaranteesByDuration.value;
          obj.ThreeGuaranteesByServiceType=threeGuaranteesByServiceType.value;
      }

  

      this.setState({
          isLoading: true,
          loadingTitle: '设置保存中...'
      })
      var that = this;
      requests({
          url: "/ListingConfig/SaveConfigValue",
          data: obj,
          success: function (res) {
              that.setState({ isLoading: false})
              if (res.Success) {
                Message({showClose: true,message: "保存设置成功！",type: 'success'});
              } else {
                Message({showClose: true,message: "保存设置失败：" + res.Message,type: 'success'});
              }
          },
          fail: (err) => { }
      });

   }

   changeDeliveryTimeliness = (e, id) => {
    let deliveryTimeliness = this.state.deliveryTimeliness;
    let checkNum = 0;
    let isOperateDeliveryTime=false;
    deliveryTimeliness.forEach((item, index) => {
        if (item.id == id) {
            item.checked = !item.checked;
        }
        if (item.checked) {
            checkNum++
        }
        item.inventoryValue = ""
    })

    deliveryTimeliness.forEach((item, index) => {
        if(item.checked && item.id==1){
            isOperateDeliveryTime=true;
            return;
        }
    })

    if(checkNum==1){
        deliveryTimeliness.forEach((item, index) => {
            if (item.checked) {
                item.inventoryValue = 100;
            }
        })
    }else if(checkNum==2){
        deliveryTimeliness.forEach((item, index) => {
            if (item.checked) {
                item.inventoryValue = 50;
            }
        })
    }else if(checkNum==3){
        let cycleIndex=0;
        deliveryTimeliness.forEach((item, index) => {
            if (item.checked) {
                ++cycleIndex;
                if(cycleIndex<3){
                    item.inventoryValue = 30;
                }else{
                    item.inventoryValue = 40;
                }                   
            }
        })
    }else if(checkNum==4){
        deliveryTimeliness.forEach((item, index) => {
            if (item.checked) {
                item.inventoryValue = 25;
            }
        })

    }

    this.setState({
        deliveryTimeliness,
        deliveryEdmit: checkNum >= 2 ? true : false,
        stockNum:100,
        isOperateDeliveryTime

    })
  }
  async syncCategory(shopId,fromUserTrigger = false){
    const data = { }
    data.TargetShopIds = [shopId]
    data.FromUserTrigger = fromUserTrigger
    this.setState({isLoading : true,loadingTitle:''})
    const res = await SyncCategoryRequest(data);
    this.setState({isLoading : false,syncCategoryMessageDailog:true})
}
selectCategory = (cateList) =>{
    if(!cateList || cateList.length == 0) return;
    this.state.customCateList = cateList;
    this.state.showSelectCategoryModule = false;
    this.setState({ })
}
confirmCategorys = (cateList) =>{
    const item = this.state.selectedListingBrandConfig;
    if(item.ListingBrandCategoryItem && cateList[0].cate_path[0] != item.ListingBrandCategoryItem[0].cate_path[0]){
        item.brandList = [];
        item.ListingBrandConfigInfo = {}
    }
    item.ListingBrandCategoryItem = cateList;
    this.state.showSelectCategoryModuleV2 = false;
    console.log(cateList)
    this.setState({ })
}
saveBrand(config,selectItem){
    const brandId = selectItem.selectObj.item.Key;
    const brandName =  selectItem.selectObj.item.Value;
    config.ListingBrandConfigInfo = {
        BrandId:brandId,
        BrandName:brandName
    }
}
brandSearch = debounceOther(async (item,key) =>{
    item.brandList =[];

    if(!key) {
      this.setState({ })
      return;
    }
    if(!item.ListingBrandCategoryItem || item.ListingBrandCategoryItem.length == 0){
        messageShow('请选择类目','info')
        this.setState({ })
        return;
    }

    const data = {};
    data.CateId = item.ListingBrandCategoryItem[0].cate_path[0];
    data.TargetShopId = this.state.selectShopId;
    data.targetPlatformType =  this.state.selectPlatformType;;
    data.QueryKey = key;
    this.setState({ isLoading : true})
    const res = await GetCategoryBrandsRequest(data);
    this.setState({ isLoading : false})
    if(res.Success){
      item.brandList = res.Data.Brands || [];
      this.setState({ })
    }
  },1000)
  addListingBrandConfig = ()=>{
    this.state.listingBrandConfig.push({ });
    this.setState({ })
  }
  delListingBrandConfig = (index)=>{
    this.state.listingBrandConfig.splice(index,1)
    if(this.state.listingBrandConfig.length == 0)
        this.state.listingBrandConfig.push({})
    this.setState({ })
  }
  initTemplteSelect= async()=>{
    if(this.state.isFirstTemplteSelect)
    {
    var postageId = "";
        if (isNotNull(this.state.selectPostageId))
            postageId = this.state.selectPostageId;
        else
            postageId = "0";

    $("select.optionTemplates").find("option[value=" + postageId + "]").prop("selected", true);
    this.setState({ isFirstTemplteSelect:false });
    }
   
  }
  initLogisticsTemplteSelect=async()=>{
    if(this.state.isFirstLogisticsTemplteSelect)
    {
     var logisticsId = "";
     if (isNotNull(this.state.selectLogisticsId))
      logisticsId = this.state.selectLogisticsId;
     else
      logisticsId = "0";

     $("select.optionLogisticsTemplates").find("option[value=" + logisticsId + "]").prop("selected", true);
     this.setState({ isFirstLogisticsTemplteSelect:false });
    }

  }


  loadTemplates = async () =>{

    const data = { };
    data.ShopId = this.state.selectShopId;
    this.setState({ isLoading:true });
    const res = await GetTemplatesBySidReqeust(data);
    this.setState({ isLoading:false });

    if (res.Success) {
        let templateId = $("#templatesSelectId").find("option:selected").val();   //运费模板id
        this.setState({
            templates: res.Data,
        },()=>{
            if(templateId){
                $("select.optionTemplates").find("option[value=" + templateId + "]").prop("selected", true);
            }
        });
    } else {
        if (res.Message != undefined && res.Message != null && res.Message.indexOf('授权') != -1) {
            this.setState({
                isShowAuth: true,
            })
        } else {
            messageShow("获取邮费模板错误：" + res.Message,'error');
        }
    }
  }

    toPlatformNewTemplate = async ()=>{
        let url = '';
        const shop = getLoginShopInfo();
        if(shop){
            if(shop.loginShopPlatformType == 'KuaiShou'){
                url = 'https://s.kwaixiaodian.com/zone/supply/express/template/list'
            }
            if(shop.loginShopPlatformType == 'TouTiao'){
                url = 'https://fxg.jinritemai.com/ffa/morder/logistics/freight-list'
            }
            if(shop.loginShopPlatformType == 'Pinduoduo'){
                url = 'https://mms.pinduoduo.com/orders/order/carriage/list'
            }
            if(shop.loginShopPlatformType == 'Taobao'){
                url = 'https://wuliu.taobao.com/user/logis_tools.htm?version=v2&tabSource=carriageTemplate'
            }
            if(shop.loginShopPlatformType == 'Taote'){
                url = 'https://ltao.seller.taobao.com/portal/iframe/wuliutools'
            }
            if(shop.loginShopPlatformType == 'XiaoHongShu'){
                url = 'https://ark.xiaohongshu.com/ark/partner/logistics/tools?tabIndex=2'
            }
            if(shop.loginShopPlatformType == 'YouZan'){
                url = 'https://shangjia.youzan.com/v4/trade/express'
            }
            if(shop.loginShopPlatformType == 'WeiMeng'){
                url = 'https://master.weimob.com/bos/products/ecSetting/'+shop.ShopId+'/678w9890kX28dts6n7X6771rog1m/setting/shopset/deliverset'
            }
        }
        if(url){
            window.open(url,'_blank')
        }
    }
   

    loadLogisticsTemplates = async () =>{

        const data = { };
        data.ShopId = this.state.selectShopId;
        this.setState({ isLoading:true });
        const res = await GetLogisticsTemplatesBySidReqeust(data);
        this.setState({ isLoading:false });
    
        if (res.Success) {
            let templateId = $("#logisticsTemplatesSelectId").find("option:selected").val();   //运费模板id
            this.setState({
                logisticsTemplates: res.Data,
            },()=>{
                if(templateId){
                    $("select.optionLogisticsTemplates").find("option[value=" + templateId + "]").prop("selected", true);
                }
            });
        } else {
            if (res.Message != undefined && res.Message != null && res.Message.indexOf('授权') != -1) {
                this.setState({
                    isShowAuth: true,
                })
            } else {
                messageShow("获取物流模板错误：" + res.Message,'error');
            }
        }
      }
    
        toPlatformNewLogisticsTemplate = async ()=>{
            let url = '';
            const shop = getLoginShopInfo();
            if(shop){                
                if(shop.loginShopPlatformType == 'XiaoHongShu'){
                    url = 'https://ark.xiaohongshu.com/app-order/logistics/tools?tabIndex=1';
                }
            }
            console.log(url);
            if(url){
                window.open(url,'_blank')
            }
        }
    changeRadioDeliveryTimeData = (e) => {
        var ids = $(e.target).find("option:selected").attr("ids");

        let deliveryTimeliness = this.state.deliveryTimeliness;
        let deliveryTimeData = this.state.deliveryTimeData;
        deliveryTimeData.forEach((item, index) => {
            if (item.id == ids) {
                if (deliveryTimeliness != null && deliveryTimeliness != undefined && deliveryTimeliness.length > 0)
                    deliveryTimeliness[0].value = item.value;
                item.checked = true
            } else {
                item.checked = false
            }
        })

        this.setState({
            deliveryTimeData,
            deliveryTimeliness: deliveryTimeliness
        })

    }



    changeRadioThreeGuarantees = (e,types) => {
        var ids = $(e.target).find("option:selected").attr("ids");
        if(types ==1)
        {
            //支持服务类型
            let threeGuaranteesByServiceTypeList = this.state.threeGuaranteesByServiceTypeList;
            threeGuaranteesByServiceTypeList.forEach((item, index) => {
                if (item.id == ids) 
                    item.checked = true
                 else 
                    item.checked = false
            })
            this.setState({threeGuaranteesByServiceTypeList:threeGuaranteesByServiceTypeList});

        }else{  
            //服务时间
            let threeGuaranteesByDurationList = this.state.threeGuaranteesByDurationList;
            threeGuaranteesByDurationList.forEach((item, index) => {
                if (item.id == ids) 
                    item.checked = true
                 else 
                    item.checked = false
            })
            this.setState({threeGuaranteesByDurationList:threeGuaranteesByDurationList});
        }
    }



    render() {

        return (
            <div className='wrap'>
                <HeaderMenu />
                <main>
                    <div className='wrap-left scroll-x' >
                        <NavMenu changeNav={this.changeNav} defaultActive={"/distributionSet"} />
                    </div>
                    <div className="wrap-right">
                    <ShowWarn isShow={this.state.isShowWarn} targetUrl={this.changeNav} 
                                    from_action={systemConfig.zhukeAlibabaAuth === false ? 'alibaba_auth_expire' : systemConfig.zhukeTaoteAuth === false ? 'taote_auth_expire' :null} 
                                    alibabaNickName={getZkShopName()} taoteNickName={getTaoteShopName()}/>

                        <div className='distriButionWrap distributionSetWrap'>
                            {
                                // this.state.selectPlatformType != 'TouTiao'?
                            <div className='mywrap distributionSet'>
                                <div className='distributionSet-title mainColor'>发布商品类目</div>
                                <div className=''>
                                    <span>智能匹配商品类目</span>
                                    <Switch
                                        value={this.state.categorySwitch}
                                        onText="开"
                                        offText="关"
                                        onChange={this.categorySwitchOnChange}
                                    >
                                    </Switch>
                                    <span style={{ marginLeft: '5px', color: "#aaa" }}>开则表示发布商品时优先使用系统智能匹配自动填充商品类目，提升发布效率</span>
                                </div>
                            </div>
                                // :<div className='mywrap distributionSet'>
                                //     <div className='distributionSet-title mainColor'>商品类目：</div>
                                //     <div className='categorySwitchWrap'>
                                //         <div className='categorySwitchWrapItem'>
                                //             <div className='categorySwitchWrapItemPart1' onClick={()=>{ this.categorySwitchOnChange(true)}}>
                                //                 <input type="radio" name='categorySwitch' value='1' checked={this.state.categorySwitch ? true:false}/>
                                //                 <span>智能匹配商品类目</span>
                                //             </div>
                                //         </div>
                                //         <div  className='categorySwitchWrapItem' style={{height:'32px'}}>
                                //             <div className='categorySwitchWrapItemPart1' onClick={()=>{ this.categorySwitchOnChange(false)}}>
                                //                 <input type="radio" name='categorySwitch' value='0'  checked={!this.state.categorySwitch ? true:false}/>
                                //                 <span>指定类目</span>
                                //             </div>
                                //             {
                                //                 !this.state.categorySwitch ?
                                //                 <div className='categorySwitchWrapItemPart2' onClick={()=>{ this.showSelectCategoryModule() }}>
                                //                     {
                                //                         this.state.customCateList && this.state.customCateList.length > 0 ?
                                //                         <span> {this.state.customCateList.map(x => x.Name).join('-')} </span>:
                                //                         <span>请选择商品类目</span>
                                //                     }
                                //                     <i className="iconfont icon-xiangxia"></i>
                                //                 </div>:null
                                //             }
                                //             <div className='categorySwitchWrapItemPart1'>
                                //             {
                                //                 !this.state.categorySwitch ?
                                //                 <div className="syncOrderWrap"> 
                                //                     <span className={"hover stopOperate"} onClick={()=>{ this.syncCategory(this.state.selectShopId,true) }}><i class="iconfont icon-tongbu"></i>同步类目</span>
                                //                 </div>:null
                                //             }
                                            
                                //             </div>
                                //         </div>
                                //         <div  className='categorySwitchWrapItem'>
                                //             <div className='categorySwitchWrapItemPart1' onClick={()=>{ this.categorySwitchOnChange(false)}}>
                                //                 <i className='commonWenHao popoverCommon'>
                                //                     <span>?</span>
                                //                     <div className='popoverCommon-warn' style={{ width: '380px', maxWidth:'380px',bottom: '22px', lineHeight: '25px', color: '#333' }}>
                                //                         <div>
                                //                             1.店铺如果有生效中的品牌，添加后，铺货对应类目的商品时，则会使用自己店铺的品牌进行铺货
                                //                         </div>
                                //                         <div>
                                //                             2.如无生效中的品牌，请勿添加
                                //                         </div>
                                //                     </div>
                                //                 </i>
                                //                 <span>品牌资质</span>
                                //             </div>
                                //             <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
                                //                 {
                                //                     this.state.listingBrandConfig.map((item,index)=>
                                //                         <div style={{display:'flex',gap:'10px',alignItems:'center'}}>
                                //                             <div className='categorySwitchWrapItemPart2' onClick={()=>{ this.showSelectCategoryModuleV2(item) }}
                                //                             style={{overflow:'hidden',flexWrap:'wrap',gap:'1px'}}>
                                //                                 {
                                //                                     item.ListingBrandCategoryItem && item.ListingBrandCategoryItem.length > 0?
                                //                                     item.ListingBrandCategoryItem.map(x =>  <span style={{backgroundColor:'#b3aeae'}}>{x.full_name}</span> )
                                //                                     : <span>请选择商品类目</span>
                                //                                 }
                                //                                 <i className="iconfont icon-xiangxia"></i>
                                //                             </div>
                                //                             <div className='categorySwitchWrapItemPart1'>
                                //                                 <SelectBox
                                //                                     selectData={ item.brandList && item.brandList.map(x => { return { title: x.Value,item:x } }) || []}
                                //                                     selectTitle={item.ListingBrandConfigInfo && item.ListingBrandConfigInfo.BrandName}
                                //                                     searchKeyword={(keyword) => { this.brandSearch(item,keyword) }}
                                //                                     onchange={(selectItem) => { this.saveBrand(item,selectItem) }}
                                //                                 >
                                //                                 </SelectBox>
                                //                             </div>
                                //                             <div>
                                //                                 <span className='iconfont icon-laji dangerColor hover' onClick={() => { this.delListingBrandConfig(index) }}></span>
                                //                             </div>
                                //                             {
                                //                                 index == this.state.listingBrandConfig.length - 1 ?
                                //                                 <div>
                                //                                     <span className='iconfont icon-jia-copy' onClick={() => { this.addListingBrandConfig() }}></span> 
                                //                                 </div>:null
                                //                             }
                                                            
                                //                         </div>
                                //                     )
                                //                 }
                                //             </div>

                                            
                                //         </div>
                                //         {/* {
                                //             this.state.brandCategorys.length > 0 ? 
                                //             <div  className='categorySwitchWrapItem'>
                                //                 <div style={{width:'70px'}}>
                                //                     <span>已选择：</span>
                                //                 </div>
                                //                 <div style={{width:'700px',display:'flex',flexWrap:'wrap',gap:'5px'}}>
                                //                     {
                                //                         this.state.brandCategorys.map(x =>  
                                //                                 <span style={{backgroundColor:'#b3aeae'}}>{x.full_name}</span>   
                                //                     )} 
                                //                 </div>
                                //             </div>:null
                                //         } */}
                                    
                                //         <span style={{ marginTop: '10px', color: "#aaa" }}>开则表示发布商品时优先使用系统智能匹配自动填充商品类目，提升发布效率</span>
                                //     </div>
                                // </div>
                            }

                            {/* 商品售价设置  start */}
                            <div className='mywrap distributionSet'>
                                <div className='distributionSet-title mainColor'>商品售价设置</div>
                                <div>
                                {this.state.selectPlatformType == "Pinduoduo" ?
                                 <div>
                                    <span>商品拼单价=货源价X</span>
                                    <span>1.08</span>
                                    <input type="hidden" value={108} id="frontSellingPriceInput" onChange={(e) => this.inputNumber(e, "frontSellingPriceInput")} placeholder="请输入" />
                                    <input type="hidden" id="laterSellingPriceInput" value={0} onChange={(e) => this.inputNumber(e, "laterSellingPriceInput")} placeholder="请输入" />
                                    {
                                         !(this.state.selectPlatformType == "TouTiao" ||this.state.selectPlatformType == "Pinduoduo") ?
                                         <div className="sellingPrice">
                                            <label>
                                                <input name="decimals" type="radio" value={true}></input>
                                                <span>保留小数</span>
                                            </label>
                                            <label>
                                                <input name="decimals" type="radio" value={false}></input>
                                                <span>四舍五入去掉小数</span>
                                            </label>
                                          </div> : null
                                        }
                                 </div>:<div>
                                   <span>商品售卖价=货源价X</span>
                                   <input type="text" id="frontSellingPriceInput" onChange={(e) => this.inputNumber(e, "frontSellingPriceInput")} placeholder="请输入" />
                                   <span>% +</span>
                                   <input type="text" id="laterSellingPriceInput" onChange={(e) => this.inputNumber(e, "laterSellingPriceInput")} placeholder="请输入" />
                                   <span>元</span>
                                   {
                                         !(this.state.selectPlatformType == "TouTiao" ||this.state.selectPlatformType == "Pinduoduo") ?
                                         <div className="sellingPrice">
                                            <label>
                                                <input name="decimals" type="radio" value={true}></input>
                                                <span>保留小数</span>
                                            </label>
                                            <label>
                                                <input name="decimals" type="radio" value={false}></input>
                                                <span>四舍五入去掉小数</span>
                                            </label>
                                          </div> : null
                                        }
                                 </div> }
                                 {
                                   this.state.selectPlatformType == "Pinduoduo"?
                                   <div className="distributionSet-two">
                                   <span style={{ marginLeft: '15px', color: 'red' }}> 注:拼多多要求上货时新商品的价格不能超过源商品价格的1.08倍，如有需要建议上货后再在官方后台修改价格</span>
                                   </div>:null
                                  }  

                                  

                                    {
                                        this.state.selectPlatformType == "TouTiao" ?
                                            <div>
                                                {this.state.selectPlatformType == "TouTiao" ? <span>商品划线价=货源价X</span> : null}
                                                <input type="text" id="frontUnderlineInput" onChange={(e) => this.inputNumber(e, "frontUnderlineInput")} placeholder="请输入" />
                                                <span>% +</span>
                                                <input type="text" id="laterUnderlineInput" onChange={(e) => this.inputNumber(e, "laterUnderlineInput")} placeholder="请输入" />
                                                <span>元</span>
                                            </div> : null
                                    }
                                    {
                                        this.state.selectPlatformType == "Pinduoduo"  ?
                                        <div>
                                                    {this.state.selectPlatformType == "Pinduoduo" ? <span>商品单买价=拼单价</span> : null}
                                                     <span> + 1</span>
                                                    <input type="hidden" id="laterUnderlineInput" onChange={(e) => this.inputNumber(e, "laterUnderlineInput")} placeholder="请输入" />
                                                    <span>元</span>
                                                </div>:null                                         
                                    }

                            {                         
                               this.state.selectPlatformType == "Pinduoduo" || this.state.selectPlatformType == "TouTiao" ?
                                <div style={{ marginTop: '5px' }}>
                                    <label>
                                        <input name="decimals" type="radio" value={true}></input>
                                        <span>保留小数</span>
                                    </label>

                                    <label>
                                        <input name="decimals" type="radio" value={false}></input>
                                        <span>四舍五入去掉小数</span>
                                    </label>
                                </div> : null
                            }
                                     

                                </div>
                            </div>
                            {/* 商品售价设置  end */}


                            {/* 库存计数设置 */}
                            {
                                this.state.selectPlatformType != "Pinduoduo"
                                    && this.state.selectPlatformType != "XiaoHongShu"
                                    && this.state.selectPlatformType != "WxVideo" ?
                                    <div className="mywrap distributionSet">
                                        <div className='distributionSet-title mainColor'>库存计数设置</div>
                                        <div className="">
                                            <label>
                                                <input name="inventorySetName" type="radio" value="CreateTime"></input>
                                                <text>买家拍下减库存</text>
                                            </label>

                                            <label>
                                                <input name="inventorySetName" type="radio" value="PayTime"></input>
                                                <text>买家付款减库存</text>
                                            </label>
                                        </div>
                                    </div> : null
                            }


                            {/* 运费模板 */}
                            <div className="mywrap distributionSet">
                                <div className='distributionSet-title mainColor'>{this.state.selectPlatformType == "XiaoHongShu"?"物流设置":"运费模板"}</div>
                                <div className="distributionSet-three">
                                    {
                                    this.state.selectPlatformType == "XiaoHongShu" ?
                                    <label>运费模板：</label>:null
                                    }
                                    <select className="optionTemplates" id="templatesSelectId">
                                        <option>请选择运费模板</option>
                                        {this.state.templates.map((item, index) =>
                                            <option value={item.Id}>{item.Name}</option>
                                        )}

                                    </select>

                                    {
                                        <div>
                                            <span className='el-button' style={{fontSize:'12px',marginLeft:'20px',border:'solid 1px #0e85f6',color:'#0e85f6'}} onClick={()=>{ this.loadTemplates()}}>同步刷新</span>
                                            <span className='el-button' style={{fontSize:'12px',marginLeft:'5px',border:'solid 1px #0e85f6',color:'#0e85f6'}} onClick={()=>{ this.toPlatformNewTemplate()}}>新建运费模板</span>
                                        </div>
                                    }
                                </div>
                                {
                                    this.state.selectPlatformType == "Pinduoduo" ?
                                        <div>
                                            <br />
                                            <span style={{ marginLeft: '15px', color: 'red' }}> 温馨提示：请务必使用大陆地区包邮（包含新疆，西藏）的运费模板，否则发布商品会失败</span>
                                        </div> : null
                                }
                                  {/* 物流模板 */}
                                  {
                                    this.state.selectPlatformType == "XiaoHongShu" ?
                                  <div className="distributionSet-three logisticsDiv">
                                     <label>物流模板：</label>
                                    <select className="optionLogisticsTemplates" id="logisticsTemplatesSelectId">
                                        <option>请选择物流模板</option>
                                        {this.state.logisticsTemplates.map((item, index) =>
                                            <option value={item.Id}>{item.Name}</option>
                                        )}

                                    </select>

                                    {
                                        <div>
                                            <span className='el-button' style={{fontSize:'12px',marginLeft:'20px',border:'solid 1px #0e85f6',color:'#0e85f6'}} onClick={()=>{ this.loadLogisticsTemplates()}}>同步刷新</span>
                                            <span className='el-button' style={{fontSize:'12px',marginLeft:'5px',border:'solid 1px #0e85f6',color:'#0e85f6'}} onClick={()=>{ this.toPlatformNewLogisticsTemplate()}}>新建物流模板</span>
                                        </div>
                                    }
                                 </div>:null
                                }
                            </div>


                            {/* 上架设置 */}
                            {
                                this.state.selectPlatformType != "KuaiShou" ?
                                    <div className="mywrap distributionSet">
                                        <div className="distributionSet-title mainColor">上架设置</div>
                                        <div className="distributionSet-three">
                                            <label>
                                                <input value={true} name="putawayName" type="radio"></input>
                                                <text>立即上架</text>
                                            </label>
                                            <label>
                                                <input name="putawayName" value={false} type="radio"></input>
                                                {this.state.selectPlatformType == "TouTiao" ? <text>存入草稿箱</text> : <text>放入仓库</text>}

                                            </label>
                                        </div>
                                    </div>
                                    :
                                    <div className="mywrap distributionSet">
                                        <div className="distributionSet-title mainColor">上架设置</div>
                                        <div className="distributionSet-three"><text>立即上架</text></div>
                                    </div>

                            }

                            {
                                this.state.selectPlatformType == "WxVideo" ?
                                    <div className="mywrap distributionSet">
                                        <div className="distributionSet-title mainColor">是否支持坏损包退</div>
                                        <div className="distributionSet-three">
                                            <label>
                                                <input name="isDamageGuaranteeName" value={1} type="radio"></input>
                                                <text>支持</text>
                                            </label>
                                            <label>
                                                <input value={2} name="isDamageGuaranteeName" type="radio"></input>
                                                <text>不支持</text>
                                            </label>
                                        </div>
                                    </div> : null
                            }

{
                                this.state.selectPlatformType == "WxVideo" ?
                                    <div className="mywrap distributionSet">
                                        <div className="distributionSet-title mainColor">是否支持假一赔三</div>
                                        <div className="distributionSet-three">
                                            <label>
                                                <input name="isFakeOnePayThreeName" value={1} type="radio"></input>
                                                <text>支持</text>
                                            </label>
                                            <label>
                                                <input value={2} name="isFakeOnePayThreeName" type="radio"></input>
                                                <text>不支持</text>
                                            </label>
                                        </div>
                                    </div> : null
                            }

                            {
                                this.state.selectPlatformType == "Pinduoduo" ?
                                    <div className="mywrap distributionSet">
                                        <div className="distributionSet-title mainColor">是否支持假一赔十</div>
                                        <div className="distributionSet-three">
                                            <label>
                                                <input value={true} name="isFoltName" type="radio"></input>
                                                <text>支持</text>
                                            </label>
                                            <label>
                                                <input name="isFoltName" value={false} type="radio"></input>
                                                <text>不支持</text>
                                            </label>
                                        </div>
                                    </div> : null
                            }



                            {
                                this.state.selectPlatformType == "Pinduoduo" ?
                                    <div className="mywrap distributionSet">
                                        <div className="distributionSet-title mainColor">是否支持七天无理由退换货</div>
                                        <div className="distributionSet-three">
                                            <label>
                                                <input value={true} name="isRefundableName" type="radio"></input>
                                                <text>支持</text>
                                            </label>
                                            <label>
                                                <input name="isRefundableName" value={false} type="radio"></input>
                                                <text>不支持</text>
                                            </label>
                                        </div>
                                    </div> : null
                            }

                            {/* 承诺发货时间 */}
                            {
                                this.state.selectPlatformType == "Pinduoduo" ?
                                    <div className="mywrap distributionSet">
                                        <div className="distributionSet-title mainColor">承诺发货时间</div>
                                        <div className="distributionSet-three">
                                            <label>
                                                <input name="PromiseDeliveryTime" type="radio" value="24"></input>
                                                <text>24小时</text>
                                            </label>
                                            <label>
                                                <input name="PromiseDeliveryTime" type="radio" value="48"></input>
                                                <text>48小时</text>
                                            </label>
                                        </div>
                                    </div> : null
                            }
                            {
                                this.state.selectPlatformType == "KuaiShou" ?
                                <div className="mywrap distributionSet">
                                        <div className="distributionSet-title mainColor">售后与承诺</div>
                                        <div className="distributionSet-four">
                                            <div className='distributionSet-four-part'>
                                                <div className='distributionSet-four-part1'>
                                                    <span className='className='distributionSet-four-title>发货时间：</span>
                                                </div>
                                                <div className='distributionSet-four-part2'>
                                                    <label>
                                                        <input name="PromiseDeliveryTime" type="radio" value="24"></input>
                                                        <text>24小时</text>
                                                    </label>
                                                    <label>
                                                        <input name="PromiseDeliveryTime" type="radio" value="48"></input>
                                                        <text>48小时</text>
                                                    </label>
                                                </div>
                                            </div>
                                            <div className='distributionSet-four-part distributionSet-four-part2'>
                                                <div className='distributionSet-four-part1'>
                                                    <span className='distributionSet-four-title'>商品服务承诺：</span>
                                                </div>
                                                <div className='distributionSet-four-part2'>
                                                    <label>
                                                        <input name="ifreshRotRefund" type="checkbox"></input>
                                                        <text>坏了包退</text>
                                                    </label>
                                                    <label>
                                                        <input name="brokenRefund" type="checkbox"></input>
                                                        <text>破损包退</text>
                                                    </label>
                                                    <label>
                                                        <input name="allergyRefund" type="checkbox"></input>
                                                        <text>过敏包退</text>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : null
                            }

                            {
                                this.state.selectPlatformType == "KuaiShou" ?
                                <div className="mywrap distributionSet">
                                    <div className='distributionSet-title mainColor'>SKU设置</div>
                                    <ul className="distributionSet-skuWrap">
                                        <li className="distributionSet-skuWrap-li">
                                            <span className="distributionSet-skuWrap-li-title">规格项大于源商品规格项，且多余规格为必填时:</span>
                                            <select name="" id="skuRequireProp" value={this.state.skuRequireProp} style={{ width: 283 }} onChange={(e)=>{ this.onChange('skuRequireProp',e.target.value) }}>
                                                <option value={'notSkuRequireProp'}>不处理，铺货报错</option>
                                                <option value={'auto'}>若需输入，则系统自动填写默认值</option>
                                            </select>
                                        </li>
                                        <li className="distributionSet-skuWrap-li">
                                            <span className="distributionSet-skuWrap-li-title">规格项小于源商品规格项时:</span>
                                            <select name="" id="skuAutoMerge" value={this.state.skuAutoMerge} style={{ width: 391 }} onChange={(e)=>{ this.onChange('skuAutoMerge',e.target.value) }}>
                                                <option value={"notMerge"}>不处理，铺货报错</option>
                                                <option value={"auto"}>模糊匹配相似规格项，多余规格属性值优先在支持自定义的规格中进行填充</option>
                                            </select>
                                        </li>
                                        <li className="distributionSet-skuWrap-li">
                                            <span className="distributionSet-skuWrap-li-title">规格名称匹配不到且不能自定义填写时:</span>
                                            <select name="" id="skuAutoFillProp" value={this.state.skuAutoFillProp} style={{ width: 331 }}  onChange={(e)=>{ this.onChange('skuAutoFillProp',e.target.value) }}>
                                               <option value={"notSkuAutoFillProp"}>不处理，铺货报错</option>
                                                <option value={'auto'}>系统自动选择规格</option>
                                            </select>
                                        </li>
                                        <li className="distributionSet-skuWrap-li" style={{display:"flex"}}>
                                            <span className="distributionSet-skuWrap-li-title">规格名称已匹配，规格值匹配不到且不能自定义时:</span>
                                            <div className="distributionSet-skuWrap-li-right">
                                                <div>
                                                    <span style={{marginLeft:'5px'}}>若需输入，则系统自动填写默认值</span>
                                                </div>
                                                <div>
                                                    <Switch
                                                        id={'skuAutoFillPropValue'}
                                                        autoWidth
                                                        checkedChildren="开"
                                                        unCheckedChildren="关"
                                                        value={this.state.skuAutoFillPropValue}
                                                        style={{ verticalAlign: "middle" }}
                                                        onChange={(val)=>{ this.onChange('skuAutoFillPropValue',val) }}
                                                    />
                                                    <span style={{marginLeft:'5px'}}>若需选择，则默认选择第—个属性选项</span>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="distributionSet-skuWrap-li">
                                            <span className="distributionSet-skuWrap-li-title">规格值输入要求为度量衡且匹配不到时：</span>
                                            <select name="" id="skuAutoFillUnitPropValue" value={this.state.skuAutoFillUnitPropValue} style={{ width: 331 }}  onChange={(e)=>{ this.onChange('skuAutoFillUnitPropValue',e.target.value) }}>
                                                <option value={'auto'}>系统默认自动填写</option> 
                                                <option value={'noHandle'}>不处理，铺货报错</option>
                                            </select>
                                        </li>
                                    </ul>
                                </div>:null
                            }


                            {/* {
                                this.state.selectPlatformType == "TouTiao" ?
                                    <div className="mywrap distributionSet">
                                        <div className="distributionSet-title mainColor">发货模式/时效</div>
                                        <div className="distributionSet-three" style={{ flexDirection: "column" }}>
                                            <div className='distributionSet-cashSale'>
                                                <ul className='distributionSet-cashSale-content'>
                                                    <li>
                                                        <div className='distributionSet-cashSale-main'>
                                                            {
                                                                this.state.deliveryTimeliness.map((item, index) =>
                                                                    item.id == 1 ?
                                                                        <div className='distributionSet-cashSale-main-one'>
                                                                            <input onChange={(e) => this.changeDeliveryTimeliness(e, item.id)} checked={item.checked} type="checkbox" name="deliveryTimelinessInputName" />
                                                                            <span>{item.name}</span>
                                                                            <select onChange={(e) => this.changeRadioDeliveryTimeData(e)} disabled={!this.state.isOperateDeliveryTime ? "disabled" : ""} >
                                                                                {
                                                                                    this.state.deliveryTimeData.map((item, index) =>
                                                                                        <option selected={item.checked} value={item.value} ids={item.id}>{item.name}</option>
                                                                                    )
                                                                                }
                                                                            </select>
                                                                        </div> :
                                                                        <label>
                                                                            <input onChange={(e) => this.changeDeliveryTimeliness(e, item.id)} checked={item.checked} type="checkbox" name="deliveryTimelinessInputName" />
                                                                            <span>{item.name}</span>
                                                                        </label>
                                                                )
                                                            }
                                                        </div>
                                                    </li>
                                                    <li className='distributionSet-cashSale-warn'>
                                                        <span className='distributionSet-warn-title'>时效规格库存</span>
                                                        <div className='distributionSet-warn-right'>
                                                            {
                                                                this.state.deliveryTimeliness.map((item, index) =>
                                                                    item.checked ?
                                                                        <label>
                                                                            {
                                                                                this.state.deliveryEdmit ?
                                                                                    <input type="text" value={item.inventoryValue} onChange={(e) => this.changeInputDeliveryTimeliness(e, item.id)} /> :
                                                                                    <input disabled type="text" value={item.inventoryValue} onChange={(e) => this.changeInputDeliveryTimeliness(e, item.id)} />
                                                                            }
                                                                            <span>%</span>
                                                                            <span className='addIcon'>+</span>
                                                                        </label> : null
                                                                )
                                                            }
                                                            {
                                                                this.state.deliveryEdmit ?
                                                                    <span className='eqSpan'>={this.state.stockNum}%</span> : null
                                                            }
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div> : null
                            }


                            {
                                 this.state.selectPlatformType == "TouTiao" ?
                                 <div>
                                    <div className="distributionSet-title mainColor">3C售后三包服务</div>
                                    <div className="distributionSet-title mainColor">
                                      <span>支持服务类型</span>
                                      <select onChange={(e) => this.changeRadioThreeGuarantees(e,1)}  >
                                            {
                                                this.state.threeGuaranteesByServiceTypeList.map((item, index) =>
                                                    <option selected={item.checked} value={item.value} ids={item.id}>{item.name}</option>
                                                )
                                            }
                                        </select>
                                      <span>服务时间</span>
                                        <select onChange={(e) => this.changeRadioThreeGuarantees(e,2)} >
                                           {
                                               this.state.threeGuaranteesByDurationList.map((item, index) =>
                                                   <option selected={item.checked} value={item.value} ids={item.id}>{item.name}</option>
                                               )
                                           }
                                       </select>
                                      <span></span>
                                    </div>
                                </div>:null
                            } */}


                            {
                                this.state.selectPlatformType == "TouTiao" ?
                                <div className="mywrap distributionSet">
                                    <div className="distributionSet-title mainColor">服务与承诺</div>
                                    <div className="distributionSet-three" style={{ flexDirection: "column" }}>
                                        <div className='distributionSet-cashSale'>
                                            <div className="distributionSet-label">发货模式/时效:</div>
                                            <ul className='distributionSet-cashSale-content'>
                                                <li className='li'>
                                                    <div className='distributionSet-cashSale-main'>
                                                        {
                                                            this.state.deliveryTimeliness.map((item, index) =>
                                                                item.id == 1 ?
                                                                    <div className='distributionSet-cashSale-main-one'>
                                                                        <input onChange={(e) => this.changeDeliveryTimeliness(e, item.id)} checked={item.checked} type="checkbox" name="deliveryTimelinessInputName" />
                                                                        <span>{item.name}</span>
                                                                        <select onChange={(e) => this.changeRadioDeliveryTimeData(e)} disabled={!this.state.isOperateDeliveryTime ? "disabled" : ""} >
                                                                            {
                                                                                this.state.deliveryTimeData.map((item, index) =>
                                                                                    <option selected={item.checked} value={item.value} ids={item.id}>{item.name}</option>
                                                                                )
                                                                            }
                                                                        </select>
                                                                    </div> :
                                                                    <label>
                                                                        <input onChange={(e) => this.changeDeliveryTimeliness(e, item.id)} checked={item.checked} type="checkbox" name="deliveryTimelinessInputName" />
                                                                        <span>{item.name}</span>
                                                                    </label>
                                                            )
                                                        }
                                                    </div>
                                                </li>
                                                <li className='distributionSet-cashSale-warn'>
                                                    <span className='distributionSet-warn-title'>时效规格库存</span>
                                                    <div className='distributionSet-warn-right'>
                                                        {
                                                            this.state.deliveryTimeliness.map((item, index) =>
                                                                item.checked ?
                                                                    <label>
                                                                        {
                                                                            this.state.deliveryEdmit ?
                                                                                <input type="text" value={item.inventoryValue} onChange={(e) => this.changeInputDeliveryTimeliness(e, item.id)} /> :
                                                                                <input disabled type="text" value={item.inventoryValue} onChange={(e) => this.changeInputDeliveryTimeliness(e, item.id)} />
                                                                        }
                                                                        <span>%</span>
                                                                        <span className='addIcon'>+</span>
                                                                    </label> : null
                                                            )
                                                        }
                                                        {
                                                            this.state.deliveryEdmit ?
                                                                <span className='eqSpan'>={this.state.stockNum}%</span> : null
                                                        }
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className='distributionSet-cashSale'>
                                            <div className="distributionSet-label">
                                                <i className='commonWenHao popoverCommon' style={{ marginRight: '4px' }}>
                                                        <span>?</span>
                                                        <div className='popoverCommon-warn' style={{ width: '200px',bottom: '22px', lineHeight: '25px', color: '#333' }}>
                                                            <span>当前商品类目命中3C商品售后三包服务并且是必填时，才生效。</span>
                                                        </div>
                                                    </i>
                                                3C售后三包服务:
                                                </div>
                                            <div className="distributionSet-cashSale-select">
                                                <span>支持服务类型</span>
                                                <select onChange={(e) => this.changeRadioThreeGuarantees(e,1)}  >
                                                    {
                                                        this.state.threeGuaranteesByServiceTypeList.map((item, index) =>
                                                            <option selected={item.checked} value={item.value} ids={item.id}>{item.name}</option>
                                                        )
                                                    }
                                                </select>
                                                <span>服务时间</span>
                                                <select onChange={(e) => this.changeRadioThreeGuarantees(e,2)} >
                                                    {
                                                        this.state.threeGuaranteesByDurationList.map((item, index) =>
                                                            <option selected={item.checked} value={item.value} ids={item.id}>{item.name}</option>
                                                        )
                                                    }
                                                </select>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div> : null
                            }

                            {
                                this.state.selectPlatformType == "TouTiao" ?
                                <div className="mywrap distributionSet">
                                    <div className='distributionSet-title mainColor'>SKU设置</div>
                                    <ul className="distributionSet-skuWrap">
                                        <li className="distributionSet-skuWrap-li">
                                            <span className="distributionSet-skuWrap-li-title">规格项大于源商品规格项，且多余规格为必填时:</span>
                                            <select name="" id="skuRequireProp" value={this.state.skuRequireProp} style={{ width: 283 }} onChange={(e)=>{ this.onChange('skuRequireProp',e.target.value) }}>
                                                <option value={'notSkuRequireProp'}>不处理，铺货报错</option>
                                                <option value={'auto'}>若需输入，则系统自动填写默认值</option>
                                            </select>
                                        </li>
                                        <li className="distributionSet-skuWrap-li">
                                            <span className="distributionSet-skuWrap-li-title">规格项小于源商品规格项时:</span>
                                            <select name="" id="skuAutoMerge" value={this.state.skuAutoMerge} style={{ width: 391 }} onChange={(e)=>{ this.onChange('skuAutoMerge',e.target.value) }}>
                                                <option value={"notMerge"}>不处理，铺货报错</option>
                                                <option value={"auto"}>模糊匹配相似规格项，多余规格属性值优先在支持自定义的规格中进行填充</option>
                                            </select>
                                        </li>
                                        <li className="distributionSet-skuWrap-li">
                                            <span className="distributionSet-skuWrap-li-title">规格名称匹配不到且不能自定义填写时:</span>
                                            <select name="" id="skuAutoFillProp" value={this.state.skuAutoFillProp} style={{ width: 331 }}  onChange={(e)=>{ this.onChange('skuAutoFillProp',e.target.value) }}>
                                            <option value={"notSkuAutoFillProp"}>不处理，铺货报错</option>
                                                <option value={'auto'}>系统自动选择规格</option>
                                            </select>
                                        </li>
                                        <li className="distributionSet-skuWrap-li" style={{display:"flex"}}>
                                            <span className="distributionSet-skuWrap-li-title">规格名称已匹配，规格值匹配不到且不能自定义时:</span>
                                            <div className="distributionSet-skuWrap-li-right">
                                                <div>
                                                    <Switch
                                                        id={'skuAutoFillPropValue'}
                                                        autoWidth
                                                        checkedChildren="开"
                                                        unCheckedChildren="关"
                                                        value={this.state.skuAutoFillPropValue}
                                                        style={{ verticalAlign: "middle" }}
                                                        onChange={(val)=>{ this.onChange('skuAutoFillPropValue',val) }}
                                                    />
                                                    <span style={{marginLeft:'5px'}}>若需选择，则默认选择第—个属性选项</span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>:null
                        }

                            {
                                this.state.selectPlatformType == "TouTiao"?
                                <div className="mywrap distributionSet">
                                        <div className='distributionSet-title mainColor'>主图视频</div>
                                        <div className="">
                                            <label>
                                                <input name="IsMigrationVideoRadio" type="radio" value="1"></input>
                                                <text>复制货源商品视频</text>
                                            </label>

                                            <label>
                                                <input name="IsMigrationVideoRadio" type="radio" value="0"></input>
                                                <text>不复制货源商品视频</text>
                                            </label>
                                            <label>
                                                <text className='hover defColor' style={{marginLeft:'10px'}} onClick={()=>{ window.open('https://school.jinritemai.com/doudian/web/article/113410?btm_pre=a2427.b4745&btm_ppre=a2427.b08003.c3401.record_1_operation_edit') }}>查看主图视频规则</text>
                                            </label>
                                        </div>
                                    </div> : null
                            }


                            {
                                this.state.selectPlatformType == "TouTiao" ?
                                    <div className="mywrap distributionSet">
                                        <div className="distributionSet-title mainColor">售后客服手机号</div>
                                        <div className="distributionSet-three">
                                            <input type="text" id="serviceMobileInput" onChange={(e) => this.inputNumber(e, "serviceMobileInput")} placeholder="请输入手机号码" />
                                        </div>
                                    </div> : null
                            }

                            {
                               this.state.selectPlatformType == "Pinduoduo"?
                               <div className="mywrap distributionSet">
                                     <div className='distributionSet-title mainColor'>过滤设置</div>
                                         <div className='distributionSet-three'>
                                             <label>
                                              <input  type="checkbox" checked disabled ></input>
                                              <text>自动过滤已铺货的商品</text>
                                             </label>
                                         </div>
                                </div> : null
                            }


                            <div className="zk-footer">
                                <Button type="primary" className="norDefBtn" onClick={() => this.saveSet()}>保存设置</Button>
                            </div>


                        </div>
                    </div>
                </main>

                <ShowModal width={"500px"} showModal={this.state.isShowAuth} hideBtn={true} >
                    <div className="showModalWrap-box-commonContent" style={{ fontSize: "16px", padding: "20px" }}>
                        <div className="showModalWrap-commonContent-item">
                            <i className="iconfont icon-gantan icofontStatus"></i>
                            <span>当前店铺授权已失效或过期，请从店铺后台重新进入使用。</span>
                            {/* <span>您有店铺授权已过期，请前往店铺列表进行授权。</span> */}
                        </div>

                        <div style={{ paddingLeft: "46px", marginBottom: "10px", marginTop: "10px" }}></div>
                        {/* <div style={{ paddingLeft: "46px", marginBottom: "10px", marginTop: "10px" }}>授权过期会影响铺货和订单回流</div> */}

                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span className="showModalWrap-box-footer-btn" onClick={() => this.gotoShopList()}>前往授权</span>
                        <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.cancelModul("isShowAuth")}>关闭</span>
                    </div>


                </ShowModal>
                <ShowModal showModal={this.state.showSelectCategoryModule} titleName={"选择类目"} cancelDailog={() => this.cancelModul("showSelectCategoryModule")} hideBtn={true} showLeftTopBtn={true}>
                    <SelectCategoryModule
                        showSelectCategoryModule={this.state.showSelectCategoryModule}
                        targetPlatformType={this.state.selectPlatformType}
                        targetShopId={this.state.selectShopId}
                        selectCategory={this.selectCategory}
                    />
                </ShowModal>
                <ShowModal showModal={this.state.showSelectCategoryModuleV2} titleName={"选择类目"} width={'780px'} cancelDailog={() => this.cancelModul("showSelectCategoryModuleV2")} hideBtn={true} showLeftTopBtn={true}>
                    <SelectCategoryModuleV2
                        showSelectCategoryModule={this.state.showSelectCategoryModuleV2}
                        targetPlatformType={this.state.selectPlatformType}
                        targetShopId={this.state.selectShopId}
                        confirmCategorys={this.confirmCategorys}
                        selectCategorys={this.state.selectedListingBrandConfig && this.state.selectedListingBrandConfig.ListingBrandCategoryItem}
                    />
                </ShowModal>

                <ShowModal showModal={this.state.syncCategoryMessageDailog} titleName={"同步类目"} width={'450px'} cancelDailog={() => this.cancelModul("syncCategoryMessageDailog")} hideBtn={true} showLeftTopBtn={true}>
                    <div style={{fontSize:'16px',marginTop:'14px',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',height:'100px'}}>
                        <div>
                            <span>同步类目成功，</span>
                            <span>预计需要1-5分钟，请稍后</span>
                        </div>
                        <div style={{fontSize:'16px',display:'flex',alignItems:'center',justifyContent:'center',height:'100px'}}>
                            <button className="sureMyBtn" onClick={() => this.cancelModul("syncCategoryMessageDailog")}>我知道了</button>
                        </div>
                    </div>
                </ShowModal>
                <MyLoading isLoading={this.state.isLoading} isStopOperate={true} fullCenter={true} />
                <NewUserGuide></NewUserGuide>
            </div>

        )
    }
}

export default distributionSet;


// WEBPACK FOOTER //
// ./src/pages/distributionSet/distributionSet.jsx